module.exports = __webpack_public_path__ + "static/img/3s-platform-img3.ced2db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-img3.png
// module id = l+cR
// module chunks = 0